import React from 'react';
import { FlexGroup, ResponsiveContainer } from '.';
import styled from '@emotion/styled';
import { LithosComponent } from './LithosComponent';

interface NavigationHeaderProps {
  children: React.ReactNode;
}

const NavigationHeader: LithosComponent<NavigationHeaderProps> = ({ children, testId = 'navigation-header' }) => {
  const Wrapper = styled.div`
    height: 100%;
    overflow: hidden;
    width: 100%;

    .compressed {
      display: none;
    }

    .full-size {
      display: block;
      padding: 0px ${({ theme }) => theme.v1.size['2']}px;
    }

    @container (max-width: ${({ theme }) => theme.v1.navigationBreakpoints.s}px) {
      .compressed {
        display: block;
      }

      .full-size {
        display: none;
      }
    }
  `;

  return (
    <ResponsiveContainer data-testid={testId}>
      <Wrapper>
        <FlexGroup alignItems="center" justifyContent="space-between" padding="0">
          {children}
        </FlexGroup>
      </Wrapper>
    </ResponsiveContainer>
  );
};

export default NavigationHeader;
